// Not used!
import { Component } from '@angular/core';

@Component({
    selector: 'mon-root',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent {}
